import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appLexTableCell]',
  standalone: false,
})
export class LexTableCellDirective {
  @Input() appLexTableCell: string;

  constructor(public template: TemplateRef<any>) {}
}
